import { RouteRecordRaw, RouterView } from 'vue-router'
const routes: RouteRecordRaw = {
  path: 'promotion/home',
  name: 'promotionHome',
  component: () => import('@/views/promotion-course/home/index.vue')
}
export default routes
